module.exports = __webpack_public_path__ + "img/school_code.27c60369.png";